import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

export const useDepartureStore = defineStore('departure', () => {
  /* State */
  const name = ref('');
  const startDate = ref('');
  const startTime = ref('');
  const location = ref('');
  const isFree = ref(false);

  /* Getters */
  const daysToStart = computed(() => {
    const now = new Date();
    const date = new Date(`${startDate.value} ${startTime.value}`);
    const diff = differenceInCalendarDays(date, now);
    const s = diff === 1 ? '' : 's';
    return `${diff} day${s}`;
  });

  return {
    name,
    startDate,
    startTime,
    location,
    isFree,
    daysToStart,
  };
});
